import { SellerLevelOneBadge, SellerLevelTwoBadge, TopRatedBadge } from '@fiverr-private/badges';
import { SELLER_LEVELS } from '../../constants';

export const SELLER_LEVEL_BADGES = {
    [SELLER_LEVELS.LEVEL_ONE]: SellerLevelOneBadge,
    [SELLER_LEVELS.LEVEL_TWO]: SellerLevelTwoBadge,
    [SELLER_LEVELS.LEVEL_TRS]: TopRatedBadge,
};
